import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./LeaderboardEpow.css";
import * as API from "../../Utils/Services/api";
import ConfettiBackground from "./ConfettiBackground";
import Footer from "../Footer/Footer";
import { useLanguage } from "../LanguageContext";
import translation from "../Translations/translation.json";
import { useSocketContext } from "../../Context/SocketContextProvider";
import { Helmet } from "react-helmet-async";
import SeoJson from "../SeoJson";
import { Spinner } from "react-bootstrap";

const formatRank = (n) => {
  if (n === 1) return "1st";
  if (n === 2) return "2nd";
  if (n === 3) return "3rd";
  return `${n}th`;
};

const LeaderboardRow = ({ rankLabel, name, score, align = "left" }) => {
  const shortName =
    name && name.length > 10 ? `${name.slice(0, 6)}...${name.slice(-4)}` : name;

  const handleCopy = (e) => {
    e.stopPropagation();
    if (!name) return;
    navigator.clipboard.writeText(name);
    toast.info("Copied Successfully!");
  };

  return (
    <div className={`lb-row lb-row--${align}`}>
      <div className="lb-rank-label">
        {" "}
        {rankLabel ? <div className="lb-rank-label">{rankLabel}</div> : null}
      </div>

      <div className="lb-pill">
        <div className="lb-pill-left">
          <div className="lb-avatar-small">
            <i className="fa fa-user" />
          </div>

          <div className="lb-pill-player">
            {shortName}
            {name && (
              <i
                className="fa fa-copy ms-1"
                style={{ cursor: "pointer" }}
                onClick={handleCopy}
              ></i>
            )}
          </div>
        </div>

        <div className="lb-pill-score">
          {Number(score || 0).toLocaleString()} AP
        </div>
      </div>
    </div>
  );
};

const PAGE_SIZE = 10;

const LeaderboardEpowio = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [topThree, setTopThree] = useState([]);
  const isSearching = !!searchTerm.trim();
  const [topGroups, setTopGroups] = useState({ 1: [], 2: [], 3: [] });

  const { socket } = useSocketContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { language } = useLanguage();
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };
  const url = `https://powdex.io/leaderboard`;
  const title = `${translate("titleBar.leaderboardMetaTitle")}`;
  const desc =
    "Track the top EthereumPoW tokens and creators on EPoW. View rankings, performance, and on-chain stats in our Leaderboard.";

  // useEffect(() => {
  //   initParticlesEngine(async (engine) => {
  //     await loadFull(engine);
  //   }).then(() => setParticlesReady(true));
  // }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);
  const normalizeAddress = (addr) => (addr || "").trim().toLowerCase();

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);

      const res = await API.getLeaderboard(
        currentPage,
        PAGE_SIZE,
        searchTerm || ""
      );

      const json = res.data;

      const items = Array.isArray(json.ranks) ? json.ranks : [];

      // let mapped = items.map((item) => ({
      //   address: normalizeAddress(item.walletAddress),
      //   score: Number(item.points || 0),
      // }));

      // mapped = mapped.sort((a, b) => b.score - a.score);
      const mapped = items.map((item) => ({
        id: item._id,
        address: normalizeAddress(item.walletAddress),
        score: Number(item.points || 0),
        rank: Number(item.rank || 0),
      }));
      // if (currentPage === 1 && !searchTerm) {
      //   const top = mapped.slice(0, 3).map((item, idx) => ({
      //     rank: idx + 1,
      //     rankLabel: formatRank(idx + 1),
      //     name: item.address,
      //     score: item.score,
      //   }));
      //   setTopThree(top);
      if (currentPage === 1 && !searchTerm) {
        const winners = mapped.filter((x) => x.rank >= 1 && x.rank <= 3);

        const groups = {
          1: winners
            .filter((x) => x.rank === 1)
            .map((x) => ({
              id: x.id,
              name: x.address,
              score: x.score,
              rank: x.rank,
              rankLabel: formatRank(x.rank),
            })),
          2: winners
            .filter((x) => x.rank === 2)
            .map((x) => ({
              id: x.id,
              name: x.address,
              score: x.score,
              rank: x.rank,
              rankLabel: formatRank(x.rank),
            })),
          3: winners
            .filter((x) => x.rank === 3)
            .map((x) => ({
              id: x.id,
              name: x.address,
              score: x.score,
              rank: x.rank,
              rankLabel: formatRank(x.rank),
            })),
        };
        setTopGroups(groups);
      }

      setLeaderboardData(mapped);
      setTotal(json.total ?? mapped.length);
    } catch (err) {
      console.error("Error fetching leaderboard:", err);
      toast.error("Failed to load leaderboard from server.");
      setLeaderboardData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLeaderboardData([]);
    setTotal(0);

    fetchLeaderboard();
  }, [currentPage, searchTerm]);
  useEffect(() => {
    if (!socket) return;

    const handlePointsUpdated = ({ walletAddress, points }) => {
      console.log("updatePoint received:", { walletAddress, points });
      if (!walletAddress) return;

      const delta = Number(points || 0);
      const normalizedWallet = normalizeAddress(walletAddress);
      setLeaderboardData((prev) => {
        const updated = [...prev];
        const idx = updated.findIndex(
          (item) => normalizeAddress(item.address) === normalizedWallet
        );

        if (idx !== -1) {
          const oldScore = Number(updated[idx].score || 0);
          updated[idx] = {
            ...updated[idx],
            score: oldScore + delta,
          };
        } else {
          // updated.push({
          //   address: walletAddress,
          //   score: delta,
          // });
          updated.push({
            id: normalizedWallet,
            address: normalizedWallet,
            score: delta,
          });
        }

        updated.sort((a, b) => b.score - a.score);
        updated.forEach((it, i) => {
          it.rank = (currentPage - 1) * PAGE_SIZE + i + 1;
          if (!it.id) it.id = it.address;
        });

        if (currentPage === 1 && !searchTerm) {
          const newTopThree = updated.slice(0, 3).map((item, idx) => ({
            rank: idx + 1,
            rankLabel: formatRank(idx + 1),
            name: item.address,
            score: item.score,
          }));
          setTopThree(newTopThree);
        }

        return updated;
      });
    };

    socket.on("updatePoint", handlePointsUpdated);

    return () => {
      socket.off("updatePoint", handlePointsUpdated);
    };
  }, [socket, currentPage, searchTerm]);
  // const rows = leaderboardData.map((item, index) => ({
  //   rank: (currentPage - 1) * PAGE_SIZE + index + 1,
  //   rankLabel: formatRank((currentPage - 1) * PAGE_SIZE + index + 1),
  //   name: item.address,
  //   score: item.score,
  // }));
  // const rows = leaderboardData.map((item, index) => {
  //   const rankNum = (currentPage - 1) * PAGE_SIZE + index + 1;

  //   return {
  //     rank: rankNum,
  //     rankLabel: isSearching ? "" : formatRank(rankNum),
  //     name: item.address,
  //     score: item.score,
  //   };
  // });
  const rows = leaderboardData.map((item) => ({
    id: item.id,
    rank: item.rank,
    rankLabel: formatRank(item.rank),
    name: item.address,
    score: item.score,
  }));
  const isFirstPage = currentPage === 1;

  const first = topThree[0];
  const second = topThree[1];
  const third = topThree[2];
  const topIds = new Set(
    [...topGroups[1], ...topGroups[2], ...topGroups[3]].map((x) => x.id)
  );
  const tableRows =
    isFirstPage && !searchTerm ? rows.filter((r) => !topIds.has(r.id)) : rows;

  // const tableRows = isFirstPage && !searchTerm ? rows.slice(3) : rows;

  const hasAnyResult = rows.length > 0;

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  const safePage = Math.min(currentPage, totalPages);

  // Split table rows into two columns
  const mid = Math.ceil(tableRows.length / 2);
  const leftPageItems = tableRows.slice(0, mid);
  const rightPageItems = tableRows.slice(mid);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  const shortAddr = (addr) =>
    addr && addr.length > 10 ? `${addr.slice(0, 6)}...${addr.slice(-4)}` : addr;

  const copyAddr = (e, addr) => {
    e.stopPropagation();
    navigator.clipboard.writeText(addr);
    toast.info("Copied Successfully!");
  };

  const useTableLayout =
    (topGroups[1]?.length || 0) > 2 ||
    (topGroups[2]?.length || 0) > 2 ||
    (topGroups[3]?.length || 0) > 2;
  const rankScore = (rank) =>
    Number(topGroups?.[rank]?.[0]?.score || 0).toLocaleString();

  const WinnerAddr = ({ addr, bold = false }) => (
    <div
      className={`lb-top-winner-addrline ${bold ? "lb-top-winner--bold" : ""}`}
    >
      {shortAddr(addr)}
      <i
        className="fa fa-copy ms-1"
        style={{ cursor: "pointer" }}
        onClick={(e) => copyAddr(e, addr)}
      />
    </div>
  );
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={desc} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={url} />
      </Helmet>

      <SeoJson
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
        }}
      />
      <main>
        <div className="view-positions-pg-leaderboard">
          <div className="container " style={{ position: "relative" }}>
            <ConfettiBackground />
            <div className="lb-root">
              <div className="lb-card">
                <h2 className="lb-title">{translate("leaderboardTitle")}</h2>
                <p className="lb-subtitle text-center">
                  {translate("leaderboardSubtitle")}
                </p>
                <div className="lb-search-bar">
                  <i className="fa fa-search lb-search-icon" />
                  <input
                    type="text"
                    className="lb-search-input"
                    placeholder={translate("searchByAddr")}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                {!hasAnyResult && (
                  <p className="lb-no-results">
                    {translate("noSearchAddr")}
                    {/* No wallets found for{" "} */}
                    <span className="lb-no-results-highlight">
                      {searchTerm || "this query"}
                    </span>
                  </p>
                )}
                {/* <div className="lb-top3">
                  {" "}
                  {second && (
                    <div className="lb-top-card lb-top-card--second lb-top-card--animated">
                      {" "}
                      <div className="lb-top-avatar">
                        {" "}
                        <img
                          src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791877/8dc3ad7b-886a-409e-aa78-2cfe613f1ad9-Picsart-AiImageEnhancer_1_auymyl.webp"
                          alt="Second place trophy"
                          className="lb-top-avatar-img"
                        />{" "}
                      </div>{" "}
                      <div className="lb-top-name">
                        {second.name.slice(0, 6)}...
                        {second.name.slice(-4)}{" "}
                        <i
                          className="fa fa-copy ms-1"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(second.name);
                            toast.info("Copied Successfully!");
                          }}
                        ></i>{" "}
                      </div>{" "}
                      <div className="lb-top-score">
                        {second.score.toLocaleString()} AP
                      </div>{" "}
                    </div>
                  )}{" "}
                  {first && (
                    <div className="lb-top-card lb-top-card--first lb-top-card--animated">
                      {" "}
                      <div className="lb-top-avatar lb-top-avatar--first">
                        {" "}
                        <img
                          src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791769/322a06cd-8099-45a6-a0f8-a437268dd8bc-Picsart-AiImageEnhancer_1_jstke8.webp"
                          alt="First place trophy"
                          className="lb-top-avatar-img"
                        />{" "}
                      </div>{" "}
                      <div className="lb-top-name lb-top-name--first">
                        {first.name.slice(0, 6)}...
                        {first.name.slice(-4)}{" "}
                        <i
                          className="fa fa-copy ms-1"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(first.name);
                            toast.info("Copied Successfully!");
                          }}
                        ></i>{" "}
                      </div>{" "}
                      <div className="lb-top-score lb-top-score--first">
                        {first.score.toLocaleString()} AP
                      </div>{" "}
                    </div>
                  )}{" "}
                  {third && (
                    <div className="lb-top-card lb-top-card--third lb-top-card--animated">
                      {" "}
                      <div className="lb-top-avatar">
                        {" "}
                        <img
                          src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791769/3d6d39e4-db01-4f4f-a943-39b1660bc70c-Picsart-AiImageEnhancer_1_1_yrkqzo.webp"
                          alt="Third place trophy"
                          className="lb-top-avatar-img"
                        />{" "}
                      </div>{" "}
                      <div className="lb-top-name">
                        {third.name.slice(0, 6)}...
                        {third.name.slice(-4)}{" "}
                        <i
                          className="fa fa-copy ms-1"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(third.name);
                            toast.info("Copied Successfully!");
                          }}
                        ></i>{" "}
                      </div>{" "}
                      <div className="lb-top-score">
                        {third.score.toLocaleString()} AP
                      </div>{" "}
                    </div>
                  )}{" "}
                </div>{" "} */}
                <div className={`${useTableLayout ? "" : "lb-top3"}`}>
                  {useTableLayout ? (
                    <div className="lb-podium-wrap mb-4">
                      <table className="lb-podium-table">
                        <thead>
                          <tr>
                            <th className="lb-podium-head lb-podium-head--second">
                              {/* <img
                              src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791877/8dc3ad7b-886a-409e-aa78-2cfe613f1ad9-Picsart-AiImageEnhancer_1_auymyl.webp"
                              alt="Second place trophy"
                              className="lb-podium-trophy"
                            /> */}
                              <div className="lb-podium-emoji lb-podium-emoji--second">
                                {/* 🥈{" "} */}
                                <img
                                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1767610847/2nd_Place_Medal-Picsart-AiImageEnhancer_1_wesb2c.webp"
                                  alt=""
                                />
                              </div>
                              {/* <div className="lb-podium-rank">2nd</div> */}
                              <div className="lb-podium-score lb-podium-score-2">
                                {rankScore(2)} AP
                              </div>
                            </th>

                            <th className="lb-podium-head lb-podium-head--first">
                              <div className="lb-podium-emoji lb-podium-emoji--first">
                                {/* 🥇 */}
                                <img
                                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1767610847/1st_Place_Medal-Picsart-AiImageEnhancer_1_wziuvc.webp"
                                  alt=""
                                />
                              </div>
                              {/* <div className="lb-podium-rank">1st</div> */}
                              <div className="lb-podium-score lb-podium-score-1">
                                {rankScore(1)} AP
                              </div>
                            </th>

                            <th className="lb-podium-head lb-podium-head--third">
                              {/* <img
                              src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791769/3d6d39e4-db01-4f4f-a943-39b1660bc70c-Picsart-AiImageEnhancer_1_1_yrkqzo.webp"
                              alt="Third place trophy"
                              className="lb-podium-trophy"
                            /> */}
                              <div className="lb-podium-emoji lb-podium-emoji--third">
                                {/* 🥉 */}
                                <img
                                  src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1767610847/3rd_Place_Medal-Picsart-AiImageEnhancer_1_fr2dxs.webp"
                                  alt=""
                                />
                              </div>
                              {/* <div className="lb-podium-rank">3rd</div> */}
                              <div className="lb-podium-score lb-podium-score-3">
                                {rankScore(3)} AP
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {Array.from({
                            length: Math.max(
                              topGroups[1].length,
                              topGroups[2].length,
                              topGroups[3].length
                            ),
                          }).map((_, i) => {
                            const first = topGroups[1][i];
                            const second = topGroups[2][i];
                            const third = topGroups[3][i];

                            return (
                              <tr key={i}>
                                <td className="lb-podium-cell">
                                  {second ? (
                                    <WinnerAddr addr={second.name} />
                                  ) : (
                                    <span className="lb-podium-empty">—</span>
                                  )}
                                </td>
                                <td className="lb-podium-cell lb-podium-cell--first">
                                  {first ? (
                                    <WinnerAddr addr={first.name} />
                                  ) : (
                                    <span className="lb-podium-empty">—</span>
                                  )}
                                </td>
                                <td className="lb-podium-cell">
                                  {third ? (
                                    <WinnerAddr addr={third.name} />
                                  ) : (
                                    <span className="lb-podium-empty">—</span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <>
                      {/* 2nd */}
                      <div className="lb-top-card lb-top-card--second lb-top-card--animated">
                        <div className="lb-top-avatar">
                          <img
                            src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791877/8dc3ad7b-886a-409e-aa78-2cfe613f1ad9-Picsart-AiImageEnhancer_1_auymyl.webp"
                            alt="Second place trophy"
                            className="lb-top-avatar-img"
                          />
                        </div>

                        <div className="lb-top-name-list">
                          <div className="lb-top-name-list">
                            {" "}
                            <div className="lb-top-score-once">
                              {rankScore(2)} AP
                            </div>
                            {topGroups[2].map((w) => (
                              <WinnerAddr key={w.id} addr={w.name} />
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* 1st */}
                      <div className="lb-top-card lb-top-card--first lb-top-card--animated">
                        <div className="lb-top-avatar lb-top-avatar--first">
                          <img
                            src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791769/322a06cd-8099-45a6-a0f8-a437268dd8bc-Picsart-AiImageEnhancer_1_jstke8.webp"
                            alt="First place trophy"
                            className="lb-top-avatar-img"
                          />
                        </div>

                        <div className="lb-top-name-list">
                          <div className="lb-top-score-once">
                            {rankScore(1)} AP
                          </div>
                          {topGroups[1].map((w) => (
                            <WinnerAddr key={w.id} addr={w.name} bold />
                          ))}
                        </div>
                      </div>

                      {/* 3rd */}
                      <div className="lb-top-card lb-top-card--third lb-top-card--animated">
                        <div className="lb-top-avatar">
                          <img
                            src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1765791769/3d6d39e4-db01-4f4f-a943-39b1660bc70c-Picsart-AiImageEnhancer_1_1_yrkqzo.webp"
                            alt="Third place trophy"
                            className="lb-top-avatar-img"
                          />
                        </div>

                        <div className="lb-top-name-list">
                          <div className="lb-top-score-once">
                            {rankScore(3)} AP
                          </div>
                          {topGroups[3].map((w) => (
                            <WinnerAddr key={w.id} addr={w.name} />
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {loading && (
                  <div className="lb-loading text-center my-3">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                )}
                {!loading && (
                  <div className="lb-lists">
                    <div className="lb-column">
                      {leftPageItems.map((entry) => (
                        <LeaderboardRow
                          key={entry.id}
                          rankLabel={entry.rankLabel}
                          name={entry.name}
                          score={entry.score}
                          align="left"
                        />
                      ))}
                    </div>

                    <div className="lb-column lb-column--right">
                      {rightPageItems.map((entry) => (
                        <LeaderboardRow
                          key={entry.id}
                          rankLabel={entry.rankLabel}
                          name={entry.name}
                          score={entry.score}
                          align="right"
                        />
                      ))}
                    </div>
                  </div>
                )}
                {rows.length > 0 && !loading && (
                  <div className="lb-pagination">
                    <button
                      className="lb-page-btn lb-page-btn--arrow"
                      disabled={safePage === 1}
                      onClick={() => goToPage(safePage - 1)}
                    >
                      ‹ {translate("paginationPrev")}
                    </button>

                    <div className="lb-page-numbers">
                      {Array.from({ length: totalPages }).map((_, idx) => {
                        const page = idx + 1;

                        if (
                          totalPages > 7 &&
                          page !== 1 &&
                          page !== totalPages &&
                          Math.abs(page - safePage) > 1
                        ) {
                          if (page === 2 || page === totalPages - 1)
                            return (
                              <span key={page} className="lb-page-ellipsis">
                                …
                              </span>
                            );
                          return null;
                        }

                        return (
                          <button
                            key={page}
                            className={`lb-page-btn ${
                              page === safePage ? "lb-page-btn--active" : ""
                            }`}
                            onClick={() => goToPage(page)}
                          >
                            {page}
                          </button>
                        );
                      })}
                    </div>

                    <button
                      className="lb-page-btn lb-page-btn--arrow"
                      disabled={safePage === totalPages}
                      onClick={() => goToPage(safePage + 1)}
                    >
                      {translate("paginationNext")} ›
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* <Footer /> */}
          </div>
        </div>{" "}
      </main>
    </>
  );
};

export default LeaderboardEpowio;
